<template>
    <div>
        <form
            id="request_form"
            @submit.prevent="otpRequest"
        >
            <y-form-field
                v-model="username"
                v-validate="'required'"
                name="request_otp"
                :placeholder="usernameLabel"
            />

            <y-button
                block
                color="blue"
                button-type="submit"
                form="request_form"
                :disabled="!username"
                loading-on="submitting-otp-request"
            >
                {{ $t('auth.send') }}
            </y-button>
        </form>
    </div>
</template>

<script>

    // Mixins
    import AuthMixin from '@/modules/auth/mixins/Auth';

    // Components
    import { YFormField } from '@deps';

    export default {
        name: 'OTPCheckUsername',

        components: {
            YFormField,
        },

        mixins: [AuthMixin],

        props: {
            settings: Object,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                model    : {},
                separator: this.$i18n.locale === 'fa' ? '، ' : ', ',
            };
        },

        computed: {
            /**
             * Return username label
             */
            usernameLabel() {
                const { usernameFields } = this.settings;
                if (!usernameFields) {
                    return this.$t('fields.username');
                }

                const labelArray = usernameFields.map((field) => this.$t(`fields.${field}`));
                return labelArray.join(this.separator);
            },

        },

        methods: {
            /**
             * Custom Login Request Otp Success action
             *
             * @param {object} response - Login Request Otp response
             */
            afterSuccessLoginRequestOtp(response) {
                this.set(this, 'model.availableChannels', {});
                this.set(this, 'model.username', this.username);
                response.data.results.channels.forEach((element) => {
                    this.model.availableChannels[element] = this.$t(`auth.otp.channels.${element}`);
                });
                this.$emit('done', this.model);
            },

            /**
             * Custom Login Request Otp error action 
             *
             * @param {object} error - Login Request Otp error
             */
            afterErrorLoginRequestOtp(error) {
                if (parseInt(error.response.data.errorCode, 10) === 404) {
                    this.$toast.error(this.$t('auth.otp.go_register'));
                    this.$router.push({ name: 'auth-register' });
                }
            },
        },
    };
</script>
